import { render, staticRenderFns } from "./EditBuddycomCallUser.vue?vue&type=template&id=4098473c&scoped=true"
import script from "./EditBuddycomCallUser.vue?vue&type=script&lang=js"
export * from "./EditBuddycomCallUser.vue?vue&type=script&lang=js"
import style0 from "./EditBuddycomCallUser.vue?vue&type=style&index=0&id=4098473c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4098473c",
  null
  
)

export default component.exports